import { render, staticRenderFns } from "./BlogEditTabInformation.vue?vue&type=template&id=5740ce20&scoped=true&"
import script from "./BlogEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./BlogEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./BlogEditTabInformation.vue?vue&type=style&index=0&id=5740ce20&lang=scss&scoped=true&"
import style1 from "./BlogEditTabInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740ce20",
  null
  
)

export default component.exports